import axios from 'axios';
import { serverUrl, apiAuthorizeKey } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';
export const NIE_TERMS_AND_CONDITIONS = 'NIE_TERMS_AND_CONDITIONS';
export const PROFILE_POLICY = 'PROFILE_POLICY';

export const getTermsandConditions = () => {
    return (dispatch, getState) => {
        return axios.get(serverUrl.EditProfile, { headers: { 'x-api-key': apiAuthorizeKey } }).then(res => {
            if (res.status === 200) {
                dispatch({ type: NIE_TERMS_AND_CONDITIONS, payload: res.data?.nie_account });
                dispatch({ type: PROFILE_POLICY, payload: res.data?.profile_consent });
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
        })
    }
}